import styled from 'styled-components';

export const ButtonAction = styled.button`
  margin-right: 2px;
  color: #f9ae17;
  font-size: 1.2rem;
  border: 0px;
  background: transparent;
  width: max-content;

  &:hover {
    color: #ff9800;
    font-size: 1.2rem;
  }
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;
